import React from "react";
import modelNodes from "./modelNodes";
import { ReactComponent as PeopleIconComponent } from "../../../assets/img/people-icon.svg";
import { ReactComponent as CheckIconComponent } from "../../../assets/img/check-icon.svg";
import Image from "../../../assets/img/Wooden_Main.jpg";
import Image2 from "../../../assets/img/Wooden_Main.jpg";
import PackagesPage from "../PackagesPage";

const title = "Wooden Hot Tub";

const breadcrumbData = [
    {
        title,
        active: true,
    },
    {
        title: "Packages",
        active: false,
    },
];

const checkBoxesData = [
    {
        label: "Spruce Premium Package",
        url: "model/1",
        image: Image2,
        price: 3199,
        oldPrice: 3399,
        id: 2,
        modelId: "2a4f2118c630400f807b933d3699ea11",
        listProps: [
            {
                icon: (
                    <React.Fragment>
                        <PeopleIconComponent />
                    </React.Fragment>
                ),
                text: "Fits 6-8 people",
            },
            {
                icon: (
                    <React.Fragment>
                        <CheckIconComponent />
                    </React.Fragment>
                ),
                text: "Special offer combo",
            },
            {
                text: "Submersible skimatic filter",
            },
        ],
    },
    {
        label: "Spruce Standard Package",
        url: "model/2",
        image: Image,
        price: 2999,
        oldPrice: 3159,
        id: 3,
        modelId: "2a4f2118c630400f807b933d3699ea11",
        listProps: [
            {
                icon: (
                    <React.Fragment>
                        <PeopleIconComponent />
                    </React.Fragment>
                ),
                text: "Fits 6-8 people",
            },
            {
                icon: (
                    <React.Fragment>
                        <CheckIconComponent />
                    </React.Fragment>
                ),
                text: "Special offer combo",
            },
        ],
    },
];

const keyFeaturesData = {
    id: 1,
    label: "Design Your Hot Tub",
    price: 2999,
    url: "custom",
    modelId: "285962f1c9a8460d9859ca0bf9a5424e",
    modelNodes,
    listProps: [
        {
            text: "Ready to ship in 1-4 weeks",
        },
    ],
};

const limitedOfferIntroData = {
    title: "Wooden <em>Specials</em>",
    text: "We carry stocks of our most popular traditional wood fired hot tubs, so they’re ready to ship as soon as you order. Check out our range of pre-configured models.",
    discount: 6,
};

const headlineData = {
    title: "Wooden Premium Package",
    discount: 6,
};

const Home = () => (
    <PackagesPage
        title={title}
        limitedOfferIntroData={limitedOfferIntroData}
        headlineData={headlineData}
        keyFeaturesData={keyFeaturesData}
        checkBoxesData={checkBoxesData}
        breadcrumbData={breadcrumbData}
    />
);

export default Home;
